import { render, staticRenderFns } from "./IngredientFormModal.vue?vue&type=template&id=b6212db4&scoped=true"
import script from "./IngredientFormModal.vue?vue&type=script&lang=ts"
export * from "./IngredientFormModal.vue?vue&type=script&lang=ts"
import style0 from "./IngredientFormModal.vue?vue&type=style&index=0&id=b6212db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6212db4",
  null
  
)

export default component.exports